import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel for PageView tracking
initMetaPixel();
render(<App data-id="element-203" />, document.getElementById('root'));